module.exports = __webpack_public_path__ + "static/media/ug.b26f273c.svg";